let React                     = require("react");
let CircuitsUtil              = require("../../../util/CircuitsUtil.js");
let ContentServerClient       = require("../../../ContentServerClient.js");

let ObservableUtil            = require("../../../util/ObservableUtil.js");
let AssetDetailsLink          = require("../../buttons/AssetDetailsLink.jsx");
let ApplicationContext        = require("../../../config/ApplicationContext.js");
let ThumbnailLinkWithSwitcher = require("../ThumbnailLinkWithSwitcher.jsx");
let ThumbnailPlaceholder      = require("../ThumbnailPlaceholder.jsx");
let CardDetails               = require("../CardDetails.jsx");

class AssetCard extends React.Component {

    constructor() {
        super();
        
        this.state = {isMouseInside: false, showInfoOverlay: false, deleted: false};
        
        
        this.getButtons = this.getButtons.bind(this);
        this.reloadResource = this.reloadResource.bind(this);
        this.toggleProperties = this.toggleProperties.bind(this);
    }
    
    componentWillMount() {
        let {id, name } = this.props.resource;
        this.addSubscription(id);
        let pathname = CircuitsUtil.getViewUrl(this.props.urlName, id, name);
        this.setState({ resource: this.props.resource, objUrl: { pathname, state: { modal: true, previousView: location.pathname }} });
    }
    
    componentWillUnmount() {
        this.removeSubscription(this.state.resource.id);
    }
    
    addSubscription(id){
       ObservableUtil.subscribeToChange("publish", id, "assetCard", (response, isError) => this.reloadResource())
       ObservableUtil.subscribeToChange("translationError", id, "assetCard", (response, isError) => this.reloadResource())
       ObservableUtil.subscribeToAction("delete", id, "assetCard", (response, isError) => this.markAsDeleted(!isError))
    }

    
    removeSubscription(id){
        ObservableUtil.unsubscribeToChange("publish", id, "assetCard");
        ObservableUtil.unsubscribeToChange("translationError", id, "assetCard", (response, isError) => this.reloadResource())
        ObservableUtil.unsubscribeToAction("delete", id, "assetCard");
    }

    markAsDeleted(deleted){
        this.setState({deleted});
    }

    reloadResource(callback){
        return ContentServerClient.getFile(this.props.handleError, `/${this.props.urlName}/${this.props.resource.id}`)
            .then(resource => this.setState({ resource }, () => {if(callback) callback(resource)}))
            .catch(eror => {if(callback) callback()})
    }

    toggleProperties(event){
        let showInfoOverlay = event.type === "mouseenter"? true : false;
        this.setState({showInfoOverlay});
    }

    getButtons(Buttons, type, failed){
        let { resource } = this.state;
       
        let status = "default";
        if(failed) status = "failed";

        if(resource.type == "3dmodel"){
            if(CircuitsUtil.modelTranslationFailed(resource)) {
                status = "failed";
            }
            if(CircuitsUtil.modelTranslationWarning(resource)) {
                status = "warning";
            }
        }
        
        if(Buttons && Buttons[type] && Buttons[type][status]){
            return  Buttons[type][status].map(Button=> <Button {...this.props} key={Button} objUrl={this.state.objUrl} />)
        }

        return  Buttons && Buttons["all"] && Buttons["all"].map(Button=> <Button {...this.props} key={Button} objUrl={this.state.objUrl} />)
                
    }

    render() {
        const {
            Action = props => <AssetDetailsLink {...props} objUrl={this.state.objUrl}/>,
            Buttons,
            loginRequired,
            layout = "grid",
            cssCardTag = "",
            showOwner = true,
            hubDeleted = false,
            noThumbnail = false,
            requireVersion = false,
            switchThumbnail = {show: false},
            thumbnailUseResource = false
        } = this.props;
        
        let { resource, deleted } = this.state;
        // check if the resource has been deleted
        if((resource.deleted === true && !this.props.isTrash) || (resource.deleted === false && this.props.isTrash)) {
             deleted = true;
        }

        let thumbnailSrc;
        if(requireVersion && CircuitsUtil.getMostRecentVersion(resource) === -1) {
            thumbnailSrc = `${ApplicationContext.assetUrlPrefix}/assets/icons/icon-no-image.svg`;
        }

        let transparentCss = (deleted)? "deleted" : "";

        return  <div className={`card ${cssCardTag} ${transparentCss}`}>

                    <div className="card__item card__gridInfo">
                        { loginRequired && layout == "grid" && !deleted &&
                            this.getButtons(Buttons, "grid")}
                    </div>

                    { !noThumbnail && <ThumbnailLinkWithSwitcher {...this.props} {...this.state} 
                                        Action={Action}
                                        layout={layout}
                                        cssCardTag={cssCardTag}
                                        requireVersion={requireVersion}
                                        switchThumbnail={switchThumbnail}
                                        thumbnailUseResource={thumbnailUseResource}
                                        noThumbnail={noThumbnail} /> 
                    }

                    { noThumbnail && <ThumbnailPlaceholder {...this.props} {...this.state}
                                        Action={Action}
                                        layout={layout}
                                        cssCardTag={cssCardTag}
                                        thumbnailUseResource={thumbnailUseResource}
                                        requireVersion={requireVersion}
                                        switchThumbnail={switchThumbnail}
                                        noThumbnail={noThumbnail} /> 
                    }

                    <CardDetails {...this.props} {...this.state} 
                        getButtons={this.getButtons} 
                        toggleProperties={this.toggleProperties}
                        Action={Action}
                        layout={layout}
                        reloadResource={this.reloadResource}
                        cssCardTag={cssCardTag}
                        requireVersion={requireVersion}
                        switchThumbnail={switchThumbnail}
                        noThumbnail={noThumbnail} 
                        showOwner={showOwner}/>

            </div>;
    }
}

module.exports = AssetCard;
